import { render } from "./SickPay.vue?vue&type=template&id=4d9ea1b0&scoped=true"
import script from "./SickPay.vue?vue&type=script&lang=js"
export * from "./SickPay.vue?vue&type=script&lang=js"

import "./SickPay.vue?vue&type=style&index=0&id=4d9ea1b0&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9ea1b0"]])

export default __exports__